/* ----------------------------------------
 * メインコンポーネント
 *-----------------------------------------*/
import Vue from 'vue';
import vuetify from '@/common/plugins/vuetify';
import router from './router';
import store from './store';
import i18n from '@/common/i18n';
import './plugins/highchart';

import App from './App.vue';

Vue.config.productionTip = false;

import { sessionModule } from '@/trials/store/modules/session';
import ErrorDialogData from '@/trials/exceptions/errorDialogData';

// 予期せぬエラーの対応
Vue.config.errorHandler = (err, vm, info) => {
    // エラーダイアログを閉じる際に初期化処理を実施
    const errorDialogData = new ErrorDialogData('error.message.default');
    errorDialogData.needInit = true;

    sessionModule.showErrorDialog(errorDialogData);
};

/* vueインスタンス */
new Vue({
    router,
    i18n,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount('#app');
